import React from "react";
import { Link as ScrollLink } from "react-scroll";

const aboutData = {
  cvpath: "media/new-resume.pdf",
  image: "/images/logo.jpg",
  name: "Adenuga Ibraheem",
  location: "Open to work",
  quickAccess: "X, Aka Twitter",
  email: "adenugaib24@gmail.com",
  aboutMe:
    "I'm Adonis, a front-end developer with over two years of experience in the industry having a solid grasp of responsive design, delivering ideal user experience (UX) and user interface (UI).I've developed my talents working on a range of projects, from static websites to complex single-page applications, and work well in both collaborative and independent environments.I am always looking to learn, up for a challenge, and excited to bring my skills and experience to a new team to help create innovative and effective solutions for our clients.",
};

function About() {
  return (
    <div className="row">
      <div className="col-md-3 logo2">
        <img src={aboutData.image} alt={aboutData.name} />
      </div>
      <div className="col-md-9">
        <h2 className="mt-4 mt-md-0 mb-4">Brief,</h2>
        <p className="mb-0">{aboutData.aboutMe}</p>
        <div className="row my-4">
          <div className="col-md-6">
            <p className="mb-2">
              Name: <span className="text-dark">{aboutData.name}</span>
            </p>
            <p className="mb-0">
              Quick Access to me: <span className="text-dark">{aboutData.quickAccess}</span>
            </p>
          </div>
          <div className="col-md-6 mt-2 mt-md-0 mt-sm-2">
            <p className="mb-2">
              Status: <span className="text-dark">{aboutData.location}</span>
            </p>
            <p className="mb-0">
              Email: <span className="text-dark">{aboutData.email}</span>
            </p>
          </div>
        </div>
        <a href={aboutData.cvpath} className="btn btn-default mr-3">
          <i className="icon-cloud-download"></i>Access CV
        </a>
        <ScrollLink
          activeClass="active"
          to="section-contact"
          spy={true}
          smooth={true}
          duration={500}
          offset={50}
          className="btn btn-alt mt-2 mt-md-0 mt-xs-2"
        >
          <i className="icon-envelope"></i>Hire me
        </ScrollLink>
      </div>
    </div>
  );
}

export default About;
